import React from 'react';
import clsx from 'clsx';

const spanClasses = (compact, error) => (
  clsx('f-12 text-r', compact ? 'w-100 mb-5' : 'mt-10', error ? 'error-text' : 'success-text')
);

const DictionaryUploadMessage = ({
  messages,
  error,
  compact,
}) => (
  <span className={spanClasses(compact, error)}>{messages}</span>
);

export default DictionaryUploadMessage;
